import { render, staticRenderFns } from "./TeamMemberItem.vue?vue&type=template&id=45740bb2&"
import script from "./TeamMemberItem.vue?vue&type=script&lang=ts&"
export * from "./TeamMemberItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports